export default __webpack_public_path__ + "static/media/image_0285.b06c1eb6.jpg";